import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';
import AssetSaleEditor from './AssetSaleEditor';

function EditAssetSale() {
	const { t } = useLabels();
	const { id } = useParams();
	const navigate = useNavigate();
	const { state } = useLocation();
	const returnTo = state?.returnTo || `/AdminScreen/assetSales/assetSale/${id}/datos`;

	return (
		<EntityList>
			<Helmet>
				<title>{`Editar ${t('entity.assetSale')}`}</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: t('entity.assetSale.plural'), to: '/AdminScreen/assetSales' },
					{ label: `Editar ${t('entity.assetSale')}` },
				]}
				title={`Editar ${t('entity.assetSale')}`}
				subtitle='Actualizá los datos de la venta.'
			/>
			<AssetSaleEditor
				mode='edit'
				assetSaleId={id}
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
			/>
		</EntityList>
	);
}

export default EditAssetSale;
